export const getLocalStorage = (key:string): string| null | false => {
  let res
  try {
    res = window.localStorage.getItem(key)
  } catch (e) {
    return false
  }
  return res
}

export const setLocalStorage = (key:string, value:string): false | undefined => {
  try {
    window.localStorage.setItem(key, value)
  } catch (e) {
    return false
  }
  return undefined
}

export const getSessionStorage = (key:string):  string| null | false=> {
  try {
   return  window.sessionStorage.getItem(key)
  } catch (e) {
    return false
  }
}

export const setSessionStorage = (key:string, value:string):false|undefined => {
  try {
    window.sessionStorage.setItem(key, value)
  } catch (e) {
    return false
  }
  return undefined
}
